<template>
  <div class="border-l-4 border-amber-400 bg-amber-50/50 rounded-r-lg overflow-hidden">
    <!-- Header with opportunity info -->
    <div class="p-3">
      <div class="font-semibold text-sm text-gray-800">
        {{ opportunityName }}
      </div>
      <div v-if="opportunityDescription" class="text-xs text-gray-600 mt-0.5">
        {{ opportunityDescription }}
      </div>
    </div>

    <!-- Work Status Section -->
    <div v-if="workStatusItems.length > 0" class="border-t border-amber-200 bg-white/50 px-3 py-2">
      <div class="flex flex-wrap gap-2">
        <div
          v-for="status in workStatusItems"
          :key="status.work_type_id"
          class="flex items-center gap-1.5 text-xs"
        >
          <!-- Status indicator -->
          <span
            :class="[
              'w-4 h-4 rounded-full flex items-center justify-center text-white text-[10px] font-medium',
              status.is_complete ? 'bg-green-500' : 'bg-gray-300'
            ]"
          >
            <template v-if="status.is_complete">&#10003;</template>
            <template v-else>{{ status.completed_count }}</template>
          </span>

          <!-- Work type label -->
          <span :class="status.is_complete ? 'text-green-700' : 'text-gray-600'">
            {{ status.work_type_abbreviated || status.work_type_display_name }}
          </span>

          <!-- Count if not complete and required > 1 -->
          <span v-if="!status.is_complete && status.required_count > 1" class="text-gray-400">
            ({{ status.completed_count }}/{{ status.required_count }})
          </span>
        </div>
      </div>
    </div>

    <!-- Priority indicator (if available) -->
    <div v-if="priorityScore" class="border-t border-amber-200 bg-white/30 px-3 py-1.5">
      <div class="flex items-center gap-2 text-xs text-gray-500">
        <span class="font-medium">Priority:</span>
        <div class="flex items-center gap-1">
          <div
            class="h-1.5 rounded-full"
            :class="priorityBarClass"
            :style="{ width: priorityBarWidth }"
          ></div>
          <span>{{ priorityScore }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OpportunityWidget',

  props: {
    opportunity: {
      type: Object,
      required: true
    }
  },

  computed: {
    opportunityName() {
      const metadata = this.opportunity.metadata || {}
      return metadata.opportunity_name ||
             metadata.contracted_measure_name ||
             metadata.measure_name ||
             'Unnamed Opportunity'
    },

    opportunityDescription() {
      const metadata = this.opportunity.metadata || {}
      return metadata.opportunity_description || null
    },

    workStatusItems() {
      return this.opportunity.work_status || []
    },

    priorityScore() {
      const metadata = this.opportunity.metadata || {}
      return metadata.priority_score || null
    },

    priorityBarWidth() {
      if (!this.priorityScore) return '0px'
      // Assuming priority score is 0-100
      const score = Math.min(100, Math.max(0, this.priorityScore))
      return `${Math.max(20, score * 0.6)}px`
    },

    priorityBarClass() {
      if (!this.priorityScore) return 'bg-gray-400'
      if (this.priorityScore >= 80) return 'bg-red-dark'
      if (this.priorityScore >= 60) return 'bg-primary-500'
      if (this.priorityScore >= 40) return 'bg-yellow-dark'
      return 'bg-green-dark'
    }
  }
}
</script>
